module.exports = __webpack_public_path__ + "static/media/payment.80a5982c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/payment.gif
// module id = 2216
// module chunks = 17